export function copyrightText(){
    return "Copyright © 2026 Universal Health Fellowship. All rights reserved.  |  Powered by CarynHealth"
}
export function version(app){
    if(process.env.REACT_APP_PORTAL === "employer"){
    return "Version 1.0.0"
    }else
    return "Version 4.0.0"
}
export function chatWithUHFcall(){
    return "Chat with a Universal Health Fellowship Representative or call "
}
export function errorMessage(apiDeatils) {
    let detail = " ";
    if(String(apiDeatils) === "Agent data is empty"){
        detail = " The agent information provided does not match our records. " 
    }
    return "An unexpected error occurred." + String(detail) +"Please try again later." 
}

export var woSmartShare = ["5688", "4395", "5689", "4396",
     "5702", "4399", "5703", "4401", "5704", "4403", "5705", 
     "4402", "5711", "4404", "5735", "4410", "5737", "4411", "5738", "4412", 
     "5739", "4413", "5743", "4600", "7701", "6550", "7702", "6551", "7703", "6552", "7705", "6556", 
     "7706", "6557", "7707", "6558", "7708", "6559", "7719", "6576", "7720", "6578", "7721", "6579","7722","6583",
      "7724", "6618", "7725", "6619", "7734", "6620", "7735", "6655", "7736", "6657", "7737", "6663", "7744", "6664", "7745", 
      "6665", "7745", "7994", "6914"]

export function isnoSmartShare (clientId){
    if (woSmartShare.includes(clientId)) return true
    else return false
}

export var planConfig = [
    {
        CLIENT_ID : '5448',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5449',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5514',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5515',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4350',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-afa-program-grid/'
    },
    {
        CLIENT_ID : '4429',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4428',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5446',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5688',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4395',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5703',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4401',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5704',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4403',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5705',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4402',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5711',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4404',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5689',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4410',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5735',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5737',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4411',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5738',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4412',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5739',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4413',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5743',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4600',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7701',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6550',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7702',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6551',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7703',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6552',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7705',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6556',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7706',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6557',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7707',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6558',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7708',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6559',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7719',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6576',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7720',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6578',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7721',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6579',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7722',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6583',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7724',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6618',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7725',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6619',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7734',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6620',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7735',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6655',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7736',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6657',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7737',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6663',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7745',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6665',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7745',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7744',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6664',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4396',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5702',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4399',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5447',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5450',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5503',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4428',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5446',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5688',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4395',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5703',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4401',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5704',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4403',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5705',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4402',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5711',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4404',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5689',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4410',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5735',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5737',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4411',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5738',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4412',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5739',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4413',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5743',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4600',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7701',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6550',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7702',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6551',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7703',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6552',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7705',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6556',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7706',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6557',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7707',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6558',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7708',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6559',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7719',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6576',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7720',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6578',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7721',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6579',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7722',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6583',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7724',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6618',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7725',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6619',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7734',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6620',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7735',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6655',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7736',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6657',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7737',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6663',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7745',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6665',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7745',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '7744',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6664',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4396',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5702',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4399',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5447',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5450',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5503',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6548',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4364',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5540',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5541',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Community-HealthShare-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4386',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5558',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4397',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5696',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5596',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4390',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-Program-Grid.pdf'
    },
	{
        CLIENT_ID : '4376',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
	{
        CLIENT_ID : '4377',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Community-HealthShare-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5550',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },    
    {
        CLIENT_ID : '4378',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5553',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4379',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5559',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '5647',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4391',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4360',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4358',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4365',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4366',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4354',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4355',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4357',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4356',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4359',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4367',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4387',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '4388',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID: '5742',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Senior-65-Brochure-Grid-(Phase-1).pdf'
    },
    {
        CLIENT_ID: '4599',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Senior-65-Brochure-Grid-(Phase-1).pdf'
    },
    {
        CLIENT_ID : '7994',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
    {
        CLIENT_ID : '6914',
        iframeURL : 'https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf'
    },
]
